/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import * as authTypes from './auth.types';

export const INITIAL_STATE = {
  newSignup: false,
  authFormType: '',
};

export const authReducer = (
  state = INITIAL_STATE,
  { type, payload }: any = {},
) =>
  produce(state, (draft) => {
    switch (type) {
      case authTypes.SET_NEW_SIGNUP:
        draft.newSignup = payload.newSignup;
        return draft;
      case authTypes.SET_AUTH_FORM_TYPE:
        draft.authFormType = payload;
        return draft;
      case authTypes.SET_AUTH_PROPERTY:
        draft = { ...state, ...payload };
        return draft;
      case authTypes.AUTHO_LOGIN:
        return {
          ...payload,
        };
      case authTypes.LOG_OUT_TRY:
        return {
          ...payload,
        };
      case authTypes.SET_AUTH0_USER:
        return {
          ...state,
          ...payload,
        };
      case authTypes.HANDLE_AUTHENTICATION_SUCCESS:
        return {
          ...state,
          ...payload,
        };
      default:
        return state;
    }
  });
